module.exports = __webpack_public_path__ + "british-virgin-islands.svg?fe6974b23aa83f5084a90dc17bf65234";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/british-virgin-islands.svg
// module id = 120
// module chunks = 10